import React from "react";

import { QRFRameProps } from "../types";

import { getPreviewFrameFontSize } from "@/utils/qrEditorHelper";
import "../styles.scss";

export const reviewFrame = (
  props: Omit<QRFRameProps, "frameType">
): React.SVGProps<SVGSVGElement> => {
  const { text, textColor, children, frameColor, frameBackgroundColor, urlQr } = props;

  const fontSize = getPreviewFrameFontSize(text?.length);

  return (
    <svg
      width="96"
      height="128"
      viewBox="0 0 96 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect
        x="0.5"
        y="0.5"
        width="95"
        height="127"
        rx="7.5"
        fill="white"
      />
      <rect
        x="0.5"
        y="0.5"
        width="95"
        height="127"
        rx="7.5"
        stroke="#BFBFBF"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M46.8785 10.0094C51.6948 9.83802 54.812 12.0205 56.2301 16.5567C56.5087 17.8628 56.4852 19.163 56.1598 20.4573C58.8321 20.4341 61.5039 20.4573 64.1754 20.527C64.6676 20.643 64.9723 20.9449 65.0894 21.4324C65.1832 27.2833 65.1832 33.1341 65.0894 38.985C64.9789 39.4145 64.7211 39.7162 64.316 39.8905C60.2379 39.9369 56.1598 39.9834 52.0816 40.0298C51.0703 41.3354 49.9921 42.5891 48.8473 43.791C48.2848 44.0697 47.7223 44.0697 47.1598 43.791C46.0816 42.5373 45.0036 41.2835 43.9254 40.0298C39.8473 39.9834 35.7691 39.9369 31.691 39.8905C31.4399 39.7811 31.2289 39.6187 31.0582 39.4029C30.8261 33.421 30.7792 27.4308 30.9176 21.4324C31.0348 20.9449 31.3394 20.643 31.8316 20.527C34.5031 20.4573 37.175 20.4341 39.8473 20.4573C39.0686 14.892 41.4123 11.4094 46.8785 10.0094ZM46.7379 10.9845C51.3982 10.7057 54.281 12.7953 55.3863 17.2533C55.6908 21.2255 53.9798 23.9419 50.2535 25.4027C46.0227 26.3137 42.9524 24.851 41.0426 21.0145C39.8698 17.2822 40.8777 14.2872 44.066 12.0293C44.9244 11.5533 45.815 11.2051 46.7379 10.9845ZM38.0191 28.537C38.3769 28.4819 38.6816 28.5748 38.9332 28.8157C39.191 29.3265 39.4488 29.8372 39.7066 30.348C40.2588 30.5089 40.8213 30.625 41.3941 30.6963C41.9462 30.7771 42.1572 31.079 42.0269 31.6018C41.6051 32.0197 41.1832 32.4376 40.7613 32.8555C40.7004 33.5395 40.7707 34.2128 40.9723 34.8755C40.8703 35.4444 40.5422 35.6302 39.9879 35.4327C39.4672 35.1748 38.9515 34.9193 38.441 34.6665C37.7848 34.9451 37.1285 35.2237 36.4723 35.5023C36.2572 35.4983 36.0931 35.4054 35.9801 35.2237C36.0117 34.4325 36.0586 33.6432 36.1207 32.8555C34.0184 31.2797 34.323 30.4671 37.0348 30.4177C37.3826 29.798 37.7108 29.1712 38.0191 28.537ZM47.7223 28.537C48.1195 28.4787 48.4241 28.618 48.6363 28.955C48.8858 29.4028 49.0967 29.8671 49.2691 30.348C49.8662 30.5222 50.4756 30.6382 51.0973 30.6963C51.5719 30.8396 51.736 31.1415 51.5894 31.6018C51.1676 32.0197 50.7457 32.4376 50.3238 32.8555C50.2933 33.5346 50.3636 34.2079 50.5348 34.8755C50.4421 35.4441 50.114 35.6299 49.5504 35.4327C49.0732 35.1035 48.5576 34.8482 48.0035 34.6665C47.4494 34.8482 46.9338 35.1035 46.4566 35.4327C46.1016 35.5575 45.7968 35.4878 45.5426 35.2237C45.6047 34.4361 45.6516 33.6468 45.6832 32.8555C45.2613 32.4376 44.8394 32.0197 44.4176 31.6018C44.271 31.1415 44.4352 30.8396 44.9098 30.6963C45.5315 30.6382 46.1408 30.5222 46.7379 30.348C47.034 29.714 47.3621 29.1103 47.7223 28.537ZM57.2848 28.537C57.5614 28.5037 57.8193 28.5501 58.0582 28.6763C58.3449 29.2677 58.6497 29.8482 58.9723 30.4177C59.6819 30.5313 60.385 30.6707 61.0816 30.8356C61.1932 30.9867 61.2869 31.1493 61.3629 31.3232C60.9912 31.9468 60.499 32.4575 59.8863 32.8555C59.8786 33.5083 59.9489 34.1585 60.0973 34.8058C60.0743 35.363 59.7931 35.572 59.2535 35.4327C58.707 35.1387 58.1445 34.8834 57.566 34.6665C56.9613 35.0007 56.3285 35.2793 55.6676 35.5023C55.3599 35.5227 55.1724 35.3834 55.1051 35.0844C55.2125 34.35 55.2593 33.6071 55.2457 32.8555C54.8238 32.4376 54.4019 32.0197 53.9801 31.6018C53.8499 31.079 54.0608 30.7771 54.6129 30.6963C55.1917 30.651 55.7542 30.5348 56.3004 30.348C56.5944 29.7184 56.9227 29.1147 57.2848 28.537Z"
        fill={frameColor}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M44.8814 14.9605C46.3158 14.8755 46.8548 15.5256 46.4986 16.9107C45.7017 17.8395 44.9049 17.8395 44.108 16.9107C43.8302 16.0299 44.088 15.3798 44.8814 14.9605Z"
        fill={frameColor}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M51.0689 14.9605C52.438 14.9329 52.9772 15.583 52.6861 16.9107C51.8892 17.8395 51.0924 17.8395 50.2955 16.9107C50.0168 16.0168 50.2745 15.3667 51.0689 14.9605Z"
        fill={frameColor}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M46.147 19.4183C46.3401 19.3964 46.5277 19.4196 46.7095 19.4879C46.8801 20.1527 47.255 20.6635 47.8345 21.0203C49.0466 21.261 49.7731 20.7734 50.0142 19.5576C50.2487 19.3718 50.4829 19.3718 50.7174 19.5576C50.8067 20.8421 50.2207 21.6547 48.9595 21.9954C47.5705 22.2016 46.6096 21.6676 46.0767 20.3934C45.9779 20.055 46.0012 19.73 46.147 19.4183Z"
        fill={frameColor}
      />
      <rect
        x="23"
        y="46"
        width="50"
        height="50"
        rx="2"
        fill={frameBackgroundColor}
      />
      <foreignObject
        width="46%"
        height="44px"
        style={{ borderRadius: "3px" }}
        x="26"
        y="49">
        <div
          id="#qrCode"
          style={{
            border: `1px solid ${frameBackgroundColor || "white"}`,
            width: "100%",
            height: "100%",
            boxSizing: "border-box",
            backgroundColor: `${frameBackgroundColor}`,
          }}>
          {urlQr ? (
            <img
              src={urlQr}
              width="100%"
              height="auto"
            />
          ) : (
            children
          )}
        </div>
      </foreignObject>
      <foreignObject
        width="100%"
        height="18px"
        y="95">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          style={{ width: "100%", height: "100%", maxWidth: "100%" }}>
          <text
            x="50%"
            y="11"
            fill={textColor}
            dominantBaseline="middle"
            textAnchor="middle"
            fontFamily="sans-serif"
            fontWeight="bold"
            style={{ fontSize }}>
            {text}
          </text>
        </svg>
      </foreignObject>
    </svg>
  );
};
